import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import AxisChartLoadingState from '../LoadingState/AxisChartLoadingState'

export const AxisChartEmptyState = (
  {
    title = 'No Data',
    subtitle,
    height,
    style = {},
    className = '',
    titleFontSize: _titleFontSize,
    subtitleFontSize: _subtitleFontSize,
    ...props
  }) => {
  const titleFontSize = _titleFontSize ?? Math.max(height / 18, 16)
  const subtitleFontSize = _subtitleFontSize ?? Math.max(height / 35, 16)

  const { grid } = props ?? {}

  return (
    <>
      <AxisChartLoadingState animate={false} {...props} />
      <div
        className={clsx('absolute top-0 bottom-0 right-0 left-0 flex flex-col align-center justify-center gap-md', className)}
        style={{
          zIndex: 10,
          margin: grid ? `${-grid.top - grid.bottom}px ${grid.left / 2}px 0 ${grid.left / 2}px` : undefined,
          pointerEvents: 'none',
          ...style
        }}
      >
        <p className='font-bold m-0 text-center' style={{ fontSize: titleFontSize, lineHeight: 0.9 }}>{title}</p>
        {subtitle?.length && (
          <p className='font-light m-0 text-center' style={{ fontSize: subtitleFontSize, lineHeight: 0.9 }}>
            {subtitle}
          </p>
        )}
      </div>
    </>
  )
}

AxisChartEmptyState.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  height: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
  titleFontSize: PropTypes.number,
  subtitleFontSize: PropTypes.number
}

export default AxisChartEmptyState
